<div class="card mt-1 bg-light">
  <div class="card-body">
    <div class="row">
      <div class="col-2">
        <h4>Patient Documents</h4>
      </div>
      @if (!showAddEhrConsultNoteReferenceForm && canModifySelectedAttachment) {
        <div
          class="col-10 patient-attachment-actions">
          @if (capture.allowConsultNoteUpload) {
            <button
              class="btn btn-secondary btn-sm"
              (click)="onUploadConsultNoteClick()">
              Upload Consult Note
            </button>
          }
          @if (capture.ehrAccess) {
            <button
              class="btn btn-secondary btn-sm"
              (click)="onAddEhrConsultNoteReferenceClick()">
              Add Consult Note Reference
            </button>
          }
        </div>
      }
    </div>
    @if (!loading) {
      <div>
        <app-verification-validation [key]="patientAttachmentValidationKey" />
        @if (canModifySelectedAttachment) {
          <section class="row mt-1">
            <div class="col-4">
              <div class="row">
                <strong>Consult Notes</strong>
              </div>
              <app-patient-document-selector
                [capture]="capture"
                [selectedAttachment]="selectedAttachment"
                [allPatientAttachments]="selectableAttachments"
                (selectionChange)="onSelectedAttachmentChange($event)"
                />
            </div>
            @if (attachmentSelectedAndVisible) {
              <div class="col-8 align-self-end">
                <div class="row">
                  <div class="col-6">
                    <app-associate-patient-document
                      [capture]="capture"
                      [selectedAttachment]="selectedAttachment"
                      (associatedAttachmentChange)="onAssociatedAttachmentChange($event)"
                      />
                  </div>
                  <div class="col-6">
                    <app-mark-patient-document-as-invalid
                      [capture]="capture"
                      [selectedAttachment]="selectedAttachment"
                      (markedAsInvalidChanged)="onMarkedAttachmentAsInvalidChange($event)"
                      />
                  </div>
                </div>
                @if (serverFailure) {
                  <div class="alert alert-danger text-danger ms-1 mt-1 p-1">
                    <strong>
                      A server error occurred while modifying the selected consult note. Please try again or contact support.
                    </strong>
                    @if (serverFailure.error) {
                      <div class="server-errors mt-1">
                        <div>{{ serverFailure.error.summary }}</div>
                        <ul class="mt-2">
                          @for (serverErrorDetail of serverFailure.error.details; track serverErrorDetail) {
                            <li>{{ serverErrorDetail }}</li>
                          }
                        </ul>
                      </div>
                    }
                  </div>
                }
              </div>
            }
          </section>
        }
        @if (attachmentSelectedAndVisible) {
          <app-patient-attachment-duplicate-link [patientAttachment]="selectedAttachment" />
        }
        @if (!canModifySelectedAttachment) {
          <section>
            @if (attachmentSelectedAndVisible && !selectedAttachment.ehrConsultNoteReference) {
              <p>
                <a href="download" (click)="onDownloadAttachmentClick($event, selectedAttachment)">
                  {{ selectedAttachment | patientAttachmentDisplayName }}
                </a>
                <a routerLink="/capture-admin/consult-notes/{{ selectedAttachment.id }}"
                  target="_blank"
                  title="Open consult note in new tab">
                  <fa-icon [icon]="['fas', 'external-link-alt']" />
                </a>
                was used to support this claim. It was imported on
                <strong>{{ selectedAttachment.createdAt | date: 'M/d/yyyy' }}</strong>
              </p>
            }
            @if (attachmentSelectedAndVisible && selectedAttachment.ehrConsultNoteReference) {
              <p>
                <strong>{{ selectedAttachment | patientAttachmentDisplayName }}</strong>
                was used to support this claim.
              </p>
            }
            @if (!selectedAttachment) {
              <div>No document was used to support this claim</div>
            }
          </section>
        }
        @if (attachmentSelectedAndVisible) {
          <section>
            <hr class="mb-2" />
            <div class="row">
              <div class="col-4 left">
                <app-patient-document-form
                  [capture]="capture"
                  [selectedAttachment]="selectedAttachment" />
              </div>
              <div class="col-8 right">
                <app-patient-document-content-processing-warning
                  [patientAttachment]="selectedAttachment"
                  [requiresRefresh]="patientAttachmentRequiresRefresh(selectedAttachment)"
                  [refreshing]="refreshingSelectedAttachment"
                  (refreshClick)="onRefreshSelectedPatientAttachmentClick()" />

                <div class="row g-0">
                  <ul class="col nav nav-tabs bg-dark ps-1 pt-1">
                    <li class="nav-item bg-dark">
                      <button type="button" class="nav-link active" id="consult-note-tab" data-bs-toggle="tab" data-bs-target="#consult-note-pdf">Consult Note</button>
                    </li>
                    <li class="nav-item bg-dark">
                      <button type="button" class="nav-link" id="summary-tab" data-bs-toggle="tab" data-bs-target="#consult-note-summary">Summary and OCR</button>
                    </li>
                  </ul>
                </div>

                <div class="tab-content">
                  <div class="tab-pane active show" id="consult-note-pdf">
                    <app-patient-document
                      [capture]="capture"
                      [selectedAttachment]="selectedAttachment" />
                  </div>
                  <div class="tab-pane auto-resize-height" id="consult-note-summary">
                    <app-consult-note-summary [patientAttachment]="selectedAttachment" [loadOnDemand]="true" />
                    <app-ocr-result-text [patientAttachment]="selectedAttachment" [loadOnDemand]="true" />
                  </div>
                </div>
              </div>
            </div>
          </section>
        }
        @if (showAddEhrConsultNoteReferenceForm) {
          <div class="row mt-3">
            <div class="col-8">
              <app-ehr-consult-note-reference-new
                [patient]="capture.patient"
                (newPatientAttachment)="onNewPatientAttachment($event)"
                (canceled)="onAddEhrConsultNoteReferenceCanceled()" />
            </div>
          </div>
        }
      </div>
    } @else {
      <mat-spinner />
    }

    <app-outreach-attempt-evidence-section
      [capture]="capture"
      [patientAttachments]="allAttachments"
      (newPatientAttachment)="onNewPatientAttachment($event)" />
  </div>
</div>

